<!-- <div class="eui-page-columns-content"> -->
    <ng-content></ng-content>
<!-- </div> -->
